import { PROJECT_DETAIL_SECTION_TITLES } from "../constants/tabs";
import { Button } from "@/components/ui/button";

interface DiaryTabHeaderProps {
  isAdmin: boolean;
  onAddVisita: () => void;
  addVisitaLoading?: boolean;
}

export default function DiaryTabHeader({
  isAdmin,
  onAddVisita,
  addVisitaLoading = false,
}: DiaryTabHeaderProps) {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-2xl font-light tracking-tight text-primary-950 dark:text-white">
        {PROJECT_DETAIL_SECTION_TITLES.diary}
      </h2>
      {isAdmin && (
        <Button
          type="button"
          onClick={onAddVisita}
          disabled={addVisitaLoading}
        >
          {addVisitaLoading ? "ADICIONANDO..." : "ADICIONAR VISITA"}
        </Button>
      )}
    </div>
  );
}
